// WhatsApp configuration for both frontend and backend
const whatsappConfig = {
  // Team members to be added to every lead's WhatsApp group
  teamMembers: [
    '+919958455611',  // Tanay
    '+919910791010', // Vishu
    '+919873767211', // Aditya
    '+919953183606', // Siraj
    '+918950204197', // Yashika
    '+918700360509', // Sejal
    '+918527354351' // Pritika
  ],
  
  // Group name template
  groupNameTemplate: {
    prefix: '✨Sumaroh | ',  // Will be combined with bride and groom name
    defaultSuffix: '- Wedding Planning'    // Used when bride and groom name is not available
  },

  // Message templates for WhatsApp communication
  messageTemplates: [
    {
      id: 'intro',
      title: 'Introduction',
      text: "I hope you're doing well!\n\nThis is *{{senderName}}* from *Sumaroh* (www.sumaroh.com). _Congratulations on your upcoming wedding!_\n\n*About Sumaroh*\nWith *8+ years* of experience and *400+ destination weddings* across India and internationally, we handle everything so you can relax and cherish the memories."
    },
    {
      id: 'portfolio',
      title: 'Portfolio Links',
      text: "In the meantime, take a look at our past work:\n\n*Website*:  https://www.sumaroh.com\n\n*Instagram*:  https://www.instagram.com/sumaroh_weddings/\n\n*YouTube*:  https://www.youtube.com/channel/UCsaqngPgDfb0GJlFwu-63lg"
    },
    {
      id: 'requirements',
      title: 'Requirements Form',
      text: "To assist you better, please share a few details with us:\n\n*Accommodation*:\n▪️ Number of rooms required: __\n▪️ Total room nights: __\n\n*Wedding Dates*:\n▪️ Day 1: __\n▪️ Day 2: __\n\n*Guest Count*:\n▪️ Mehendi (Day 1): __\n▪️ Sangeet (Day 1): __\n▪️ Haldi (Day 2): __\n▪️ Wedding (Day 2): __\n\n*Couple Details*:\n▪️ Bride's Name: __\n▪️ Groom's Name: __\n\n*Preferences*:\n\n1️⃣ Alcohol at which functions? \n\n2️⃣ Menu preference – Veg, Non-Veg, or Both?\n\n3️⃣ Which cities are you considering for the venue?\n\n4️⃣ Any specific venue type in mind?"
    },
    {
      id: 'followup',
      title: 'Follow Up',
      text: "Hello! 👋\n\nJust following up on our previous conversation about your wedding plans. Are you still interested in discussing the details? I'm here to help! 😊"
    },
    {
      id: 'consultation',
      title: 'Schedule Consultation',
      text: "Would you like to schedule a *consultation call* to discuss your wedding plans in detail?\n\nWe can go through your requirements and how we can help make your special day perfect. ✨"
    },
    {
      id: 'call_not_picked',
      title: 'Call Not Picked',
      text: "Hi,\n\nI tried reaching you but couldn't get through. No worries! Let me know a convenient time, and I'll be happy to call again.\n\nLooking forward to connecting!\n\nBest,  \n*{{senderName}} from Sumaroh*"
    }
  ]
};

export default whatsappConfig;

// For CommonJS compatibility in backend
if (typeof module !== 'undefined' && module.exports) {
  module.exports = whatsappConfig;
}
